import useGetUsers from './useGetUsers'

export default useGetUsers
